import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private baseUrl = environment.apiUrl + '/v1/profiles';

  constructor(private http: HttpClient) {}

  getStaff(page = 0, size = 100, status?: string) {
    let url = `${this.baseUrl}/staff?page=${page}&size=${size}`;
    if (status) url += `&status=${status}`;
    return this.http.get(url);
  }

  getStaffById(id: number) {
    return this.http.get(`${this.baseUrl}/staff/${id}`);
  }

  registerStaff(payload: {
    username: string;
    roleId: number;
    organisationId: number;
    firstName: string;
    lastName: string;
    email: string;
    dateOfBirth: string;
    department: string;
    staffPosition: string;
  }) {
    return this.http.post(`${this.baseUrl}/register/staff`, payload);
  }

  deleteStaff(id: number) {
    return this.http.delete(`${this.baseUrl}/staff/${id}`);
  }

  getStudents(page = 0, size = 10, status?: string) {
    let url = `${this.baseUrl}/students?page=${page}&size=${size}`;
    if (status) url += `&status=${status}`;
    return this.http.get(url);
  }

  deleteStudent(id: number) {
    return this.http.delete(`${this.baseUrl}/students/${id}`);
  }
}